// Bonza Business Value Estimator - Constants

export const INDUSTRIES = [
  'Accommodation/Tourism',
  'Animals and Pets',
  'Automotive',
  'Beauty/Health',
  'Building/Trade',
  'Business/Property',
  'Commercial Services',
  'Ecommerce',
  'Education/Training',
  'Finance',
  'Food/Hospitality',
  'Franchise',
  'Greenfield Franchise',
  'Home/Garden',
  'Import/Export/Wholesale',
  'Industrial/Manufacturing',
  'Leisure/Entertainment',
  'Manufacturing',
  'NDIS',
  'Professional',
  'Professional Services',
  'Retail',
  'Rural',
  'Services',
  'Technology',
  'Transport/Distribution'
];

export const SUBCATEGORIES = {
  'Building/Trade': [
    'Electrical',
    'Plumbing',
    'Building/Construction',
    'Carpentry',
    'Painting',
    'Roofing',
    'Landscaping',
    'Air Conditioning/HVAC',
    'Tiling',
    'Concreting',
    'Other Building/Trade'
  ],
  'Commercial Services': [
    'Cleaning',
    'Pest Control',
    'Security',
    'Gardening/Maintenance',
    'Waste Management',
    'Printing',
    'Signage',
    'Other Commercial Services'
  ],
  'Food/Hospitality': [
    'Cafe',
    'Restaurant',
    'Takeaway',
    'Bakery',
    'Catering',
    'Bar/Pub',
    'Fast Food',
    'Food Manufacturing',
    'Other Food/Hospitality'
  ],
  'Beauty/Health': [
    'Hair Salon',
    'Beauty Salon',
    'Day Spa',
    'Massage',
    'Gym/Fitness',
    'Pilates/Yoga',
    'Allied Health',
    'Pharmacy',
    'Other Beauty/Health'
  ],
  'Manufacturing': [
    'Food Manufacturing',
    'Metal Fabrication',
    'Plastic/Rubber',
    'Textile',
    'Furniture',
    'Machinery',
    'Other Manufacturing'
  ],
  'Professional Services': [
    'Accounting/Bookkeeping',
    'Legal',
    'Marketing/Advertising',
    'IT Services',
    'Consulting',
    'Recruitment',
    'Financial Planning',
    'Real Estate',
    'Other Professional Services'
  ],
  'Retail': [
    'Fashion/Clothing',
    'Electronics',
    'Furniture/Homewares',
    'Sports/Outdoor',
    'Pet Supplies',
    'Newsagent/Lottery',
    'Convenience Store',
    'Specialty Retail',
    'Other Retail'
  ]
};

export const REVENUE_TREND_OPTIONS = [
  { value: 'significantly-increasing', label: 'Significantly increasing' },
  { value: 'slightly-increasing', label: 'Slightly increasing' },
  { value: 'stable', label: 'Stable' },
  { value: 'slightly-decreasing', label: 'Slightly decreasing' },
  { value: 'significantly-decreasing', label: 'Significantly decreasing' }
];

export const STATES = ['QLD', 'NSW', 'VIC', 'WA', 'TAS', 'NT', 'ACT', 'SA'];

export const LEASE_LENGTH_OPTIONS = [
  { value: 'less-than-1', label: 'Less than 1 year' },
  { value: '1-2', label: '1–2 years' },
  { value: '3-4', label: '3–4 years' },
  { value: '4-6', label: '4–6 years' },
  { value: 'over-6', label: 'Over 6 years' }
];

export const SELLING_INTENT_OPTIONS = [
  { value: 'yes', label: 'Yes, planning to sell' },
  { value: 'maybe', label: 'Maybe, exploring options' },
  { value: 'no', label: 'No, just curious' }
];

// Industries with HIGH buyer demand
export const HIGH_DEMAND_INDUSTRIES = [
  'Accommodation/Tourism',
  'Animals and Pets',
  'Automotive',
  'Beauty/Health',
  'Food/Hospitality',
  'Franchise',
  'Home/Garden',
  'NDIS',
  'Retail',
  'Services',
  'Transport/Distribution',
  'Ecommerce'
];

// Industries with STEADY buyer demand
export const STEADY_DEMAND_INDUSTRIES = [
  'Building/Trade',
  'Commercial Services',
  'Education/Training',
  'Import/Export/Wholesale',
  'Manufacturing',
  'Professional Services',
  'Technology'
];

// Industries with SPECIALISED buyer demand
export const SPECIALISED_DEMAND_INDUSTRIES = [
  'Finance',
  'Rural',
  'Business/Property',
  'Greenfield Franchise',
  'Industrial/Manufacturing',
  'Professional'
];

// Subcategories that use cleaning/pest/gardening rules (revenue-based)
export const REVENUE_BASED_SUBCATEGORIES = [
  'Cleaning',
  'Pest Control',
  'Gardening/Maintenance'
];
